<template>
  <footer class="the-footer flex-wrap justify-between">
    <p class="vx-row" dir="ltr">
      <span class="vx-col">
        <span dir="ltr">{{ $t('messages.support_tel') | persian_digits }}</span>
        {{ $t('messages.support') }}
      </span>
      <span class="vx-col">30Teb v{{ $version }} &copy; {{ new Date().getFullYear() }}</span>
    </p>
  </footer>
</template>

<script>
export default {
  name: 'the-footer'
}
</script>
